import React from 'react';
import ValidateAccountLayer from '../components/ValidateAccountLayer';
import Breadcrumb from '../components/Breadcrumb';

const ValidateAccount = () => {
    return (
        <div className="container pt-50">
            <Breadcrumb title="Validar conta" icon="solar:shield-check-outline" />
            {/* CompanyLayer */}
            <ValidateAccountLayer />
        </div>
    );
};

export default ValidateAccount;
